/*
==============================================================================
POPUP RICHIESTA INFORMAZIONI PER ARTICOLI NON DISPONIBILI
------------------------------------------------------------------------------
==============================================================================
*/
$('#popup-unavailable').on('click', '#submit-article-unavailable', function () {

  const $errore = $('#popup-unavailable .error-message');

  // var form = $('#popup-unavailable form');
  const $pulsante = $('#submit-article-unavailable');

  const aremail = $('input[name="article_email"]').val();
  let arnome = $('input[name="article_nome"]').val();
  let arcognome = $('input[name="article_cognome"]').val();

  const arid = $('input[name="article_id"]').val();
  const arname = $('input[name="article_name"]').val();

  // Controllo se i valori esistono
  if (aremail === undefined || aremail === null || !aremail.length) {
    $errore.text('ERRORE - IL CAMPO EMAIL E\' OBBLIGATORIO');
    return;
  }
  if (arnome === undefined || arnome === null || !arnome.length) {
    $errore.text('ERRORE - IL CAMPO NOME E\' OBBLIGATORIO');
    return;
  }
  if (arcognome === undefined || arcognome === null || !arcognome.length) {
    $errore.text('ERRORE - IL CAMPO COGNOME E\' OBBLIGATORIO');
    return;
  }

  // controllo se l'indirizzo email è formalmente valido
  const re = /.+@.+\..+/i;
  if (re.test(aremail) === false) {
    $errore.text('ERRORE - INDIRIZZO EMAIL NON VALIDO');
    return;
  }

  // Rimuovo qualsiasi carattere non conforme (speciale) dal nome e dal cognome
  arnome = arnome.replace(/[^\w\s]/gi, '');
  arcognome = arcognome.replace(/[^\w\s]/gi, '');


  // Mostro lo spinner sul pulsante
  $pulsante.html('<span class="fa fa-spinner fa-spin fa-lg"></span>');

  // Preparo i dati per la post
  // var formData = $('#article-unavailable').serialize();
  const formUrl = $('#article-unavailable').attr('action');

  $.ajax({
    url: formUrl,
    type: 'POST',
    data: {
      article_email: aremail,
      article_nome: arnome,
      article_cognome: arcognome,
      article_id: arid,
      article_name: arname
    },
  }).success(function (data) {

    // Tutto bene
    if (data === 'ok') {

      $('#popup-unavailable .unavailable-body').addClass('hidden');
      $('#popup-unavailable .unavailable-success').removeClass('hidden');

      // Iscrivo la persona automaticamente alla newsletter
      const lista = 1;
      const gruppo = 29;
      const ritCodice = 1;
      const conferma = false;
      const csvFldNames = 'campo1;campo2;';
      const csvFldValues = '' + arnome + ';' + arcognome + ';';
      // Eseguo l'iscrizione
      $.ajax({
        url: '../proxy_newsletter.php',
        type: 'POST',
        data: {
          list: lista,
          group: gruppo,
          retCode: ritCodice,
          confirm: conferma,
          email: aremail,
          csvFldNames: csvFldNames,
          csvFldValues: csvFldValues
        },
        success: function (result) {
          console.log(result);
        }
      });

      // Setto il cookie mail da utilizzare per il retargeting
      /* eslint-disable no-undef */
      // setRtMail(aremail);

    } else {
      $errore.text(data);
    }

  });

});
